__turbopack_context__.v({
  "modalBody": "_4TLv_W_modalBody",
});
